<template>
  <div>
    <!-- <v-select
      v-model="actualPrinter"
      :options="printers"
      class="margin-multi sp-border-input bg-white w-25 mb-2"
      placeholder="Impresora"
    /> -->
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex sp-flex justify-content-between text-sm align-items-center catalogo-text"
          >
            Catálogo de ubicaciones
            <router-link class="sp-margin-b" :to="{ name: 'NuevoUbicacion' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Ubicación
              </CButton>
            </router-link>
            <!-- <div class="sp-margin-b">
              <CButton
                @click="selectAll()"
                color="primary"
                class="mr-1 sp-width-butom  d-flex "
              >
                <CIcon class="mr-1" name="cil-check" />Seleccionar Todos
              </CButton>
            </div>
            <div class="sp-margin-b">
              <CButton
                @click="printModal = true"
                color="primary"
                class="mr-1 sp-width-butom  d-flex "
              >
                <CIcon class="mr-1" name="cil-barcode" />Imprimir Codigos
              </CButton>
            </div> -->
          </CCardHeader>
          <CCardBody>
            <!-- <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div> -->
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="filteredItems"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
              pagination
            >
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput
                      v-model="filter"
                      placeholder="Búsqueda por ubicaciones..."
                    />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-print" />
                        </CButton>
                      </template>

                      <CDropdownItem
                        @click="onClickPrintCodes"
                        class="no-padding"
                      >
                        <div class="custom-padding">
                          <CIcon class="mr-1" name="cil-print" />Imprimir
                          Codigos
                        </div>
                      </CDropdownItem>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #check-header>
                <div class="text-center" @click="selectAll()">
                  <CIcon v-if="allSelections" name="cil-x-circle" />
                  <CIcon v-else name="cil-check" />
                </div>
              </template>
              <template #nombre="{item, index}">
                <td v-if="filter" class="py-2 ">
                  {{ item.payload.nombre }}
                </td>
                <td
                  v-else
                  class="py-2"
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                  @click="toggleUbicaciones(index)"
                >
                  <span>
                    <CIcon
                      v-if="
                        items.filter(
                          hijo => hijo.payload.pertenece_id == item.id
                        ).length > 0
                      "
                      name="cil-chevron-circle-down-alt"
                    />
                  </span>
                  {{ item.payload.nombre }}
                </td>
              </template>
              <template #cultivo="{item, index}">
                <td v-if="filter" class="py-2 ">
                  {{
                    item.payload.cultivo_id == 0
                      ? ""
                      : getCultivo(item.payload.cultivo_id)
                  }}
                </td>
                <td
                  v-else
                  class="py-2 "
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                  @click="toggleUbicaciones(index)"
                >
                  {{
                    item.payload.cultivo_id == 0
                      ? ""
                      : getCultivo(item.payload.cultivo_id)
                  }}
                </td>
              </template>
              <template #activo="{item}">
                <td class="py-2">
                  <CSwitch
                    v-if="isLeaf(item.id)"
                    :checked="!item.payload.suspendido"
                    @update:checked="() => toggleSuspendido(item)"
                    class="mx-1"
                    color="primary"
                    variant="3d"
                  />
                </td>
              </template>
              <template #check="{item}">
                <td class="py-2 custom-control custom-checkbox">
                  <p-check
                    class="p-svg p-curve"
                    name="check"
                    color="success"
                    v-model="item.selected"
                  >
                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                      <path
                        d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        style="stroke: white;fill:white"
                      />
                    </svg>
                    Imprimir
                  </p-check>
                </td>
              </template>
              <template #print="{item}">
                <td class="py-2">
                  <CButton
                    color="info"
                    @click="printNanoid(item)"
                    square
                    size="sm"
                    >Imprimir</CButton
                  >
                </td>
              </template>
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{ name: 'EditarUbicacion', params: { id: item.id } }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #space="{item,index}">
                <td class="py-2">
                  <CButton
                    :disabled="
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? true
                        : false
                    "
                    color="danger"
                    @click="toggleCancel(index, item)"
                    square
                    size="sm"
                    >Borrar</CButton
                  >
                </td>
              </template>

              <template v-if="!filter" #details="{item, index}">
                <CCollapse :show="details.includes(index)">
                  <!-- <CCardBody class="py-0 px-0 pl-2"> -->
                  <table-collapse
                    :isLeaf="isLeaf"
                    :toggleSuspendido="toggleSuspendido"
                    @click-cancel="toggleCancel"
                    @click-print="printNanoid"
                    :ubicacionPadre="item.id"
                    :cultivos="cultivos"
                    :ubicaciones="
                      items
                        .filter(hijo => hijo.payload.raiz_id == item.id)
                        .sort((a, b) =>
                          a.payload.nombre.localeCompare(b.payload.nombre)
                        )
                    "
                  ></table-collapse>
                </CCollapse>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar la ubicación {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Ubicación</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteUbicacion(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <CModal
      :show.sync="printModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Imprimir Ubicaciones"
      color="info"
    >
      <label>Impresora</label>
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white  mb-2"
        placeholder="Impresora"
      />
      <CInput
        label="Cantidad de impresiones"
        v-model="itemModalPrint.cantidadCopias"
        placeholder="Cantidad de impresiones"
        type="number"
      ></CInput>
      <template #header>
        <h5 class="modal-title">Imprimir Ubicaciones</h5>
        <CButtonClose @click="printModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="printModal = false" color="danger">Cancelar</CButton>
        <CButton @click="printItems()" color="success">Aceptar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PrettyCheck from "pretty-checkbox-vue/check";

const fields = [
  { key: "nombre", _style: "width:50%" },
  { key: "cultivo", _style: "width:50%" },
  { key: "activo", _style: "width:50%" },
  {
    key: "check",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  // {
  //   key: "print",
  //   label: "",
  //   _style: "width: 10%",
  //   sorter: false,
  //   filter: false
  // },
  {
    key: "edit",
    label: "",
    _style: "width: 10%",
    sorter: false,
    filter: false
  },
  {
    key: "space",
    label: "",
    _style: "width: 10%",
    sorter: false,
    filter: false
  }
  //, {
  //   key: "cancel",
  //   label: "",
  //   _style: "width:1%",
  //   sorter: false,
  //   filter: false
  // }
];

import TableCollapse from "../../customComponents/TableCollapse";

export default {
  name: "Ubicaciones",

  components: {
    TableCollapse,
    vSelect,
    "p-check": PrettyCheck
  },

  data() {
    return {
      items: [],
      cultivos: [],
      fields,
      filter: "",
      dropdownCustom: false,
      allSelections: false,
      cancelModal: false,
      details: [],
      isLoading: false,
      printModal: false,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      itemModalPrint: { cantidadCopias: 1 },
      itemModal: { id: "", name: "", index: "" }
    };
  },

  created() {
    window.printSetup();
    this.updateAllInfo();
  },

  computed: {
    printers() {
      // console.log(window.printersDetected);

      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
      // ? { value: window.printerAct.uid, label: window.printerAct.name }
      // : null;
    },
    filteredItems() {
      const getDatos = () => {
        if (this.filter) {
          console.log(
            this.cultivos.map(m => m.payload),
            this.items.map(m => m.payload._relaciones.cultivo?.payload)
          );
          return this.items.filter(
            i =>
              i.payload.nombre
                .toLowerCase()
                .includes(this.filter.toLowerCase()) ||
              (i.payload._relaciones.cultivo?.payload?.nombre || "")
                .toLowerCase()
                .includes(this.filter.toLowerCase()) ||
              (i.payload._relaciones.cultivo?.payload?.variedad || "")
                .toLowerCase()
                .includes(this.filter.toLowerCase())
          );
        } else {
          return this.items.filter(i => i.payload.pertenece_id == 0);
          // .filter(i =>
          //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
          // );
        }
      };
      return getDatos().sort((a, b) =>
        a.payload.nombre.localeCompare(b.payload.nombre)
      );
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateAllInfo();
    }
  },

  methods: {
    onClickPrintCodes() {
      this.printModal = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: false };
            })
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(ubi => {
              return { ...ubi, selected: true };
            })
          : [];
        this.allSelections = true;
      }
    },
    printItems() {
      const idsToPrint = this.items.filter(item => item.selected === true);
      // console.log(idsToPrint);
      idsToPrint.length
        ? idsToPrint.map(ubicacion => {
            this.printNanoid(ubicacion, this.itemModalPrint.cantidadCopias);
          })
        : null;

      this.printModal = false;
    },
    printNanoid(ubicacion, cant) {
      //console.log("print");

      if (ubicacion && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${ubicacion.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${ubicacion.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    getCultivo(cultivo_id) {
      const cultivoActual = this.cultivos.find(
        cultivo => cultivo.id == cultivo_id
      );

      return `${cultivoActual?.payload?.nombre || ""} ${cultivoActual?.payload
        ?.variedad || ""}`;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    toggleUbicaciones(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    deleteUbicacion(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "ubicaciones",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    },
    isLeaf(id) {
      return this.items.every(e => e.payload.pertenece_id !== id);
    },
    toggleSuspendido(item) {
      this.isLoading = true;
      this.$store
        .dispatch("customActualizarHTTP", {
          schema: "ubicaciones",
          id: item.id,
          payload: {
            ...item.payload,
            suspendido: !item.payload.suspendido
          }
        })
        .then(() => {
          // console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.updateAllInfo(this.page);
          this.isLoading = false;
        });
    },

    updateAllInfo() {
      const ubicacionTemplateRaiz = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          "with-storage": ["*"],
          filter: {
            where: [
              {
                field: "payload->raiz_id",
                value: this.ubicacionRaizValue,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      const ubicacionTemplateNoRaiz = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        })
      ];
      this.isLoading = true;
      const ubi = [
        this.$store.dispatch("customHTTP", { schema: "cultivos" })
        // this.$store.dispatch("customHTTP", { schema: "ubicaciones" })
      ];

      if (this.ubicacionRaizValue) {
        ubi.push(...ubicacionTemplateRaiz);
      } else {
        ubi.push(...ubicacionTemplateNoRaiz);
      }

      // this.$store
      //   .dispatch("customHTTP", { schema: "ubicaciones" })
      Promise.all(ubi)
        .then(([cultivos, ubicaciones]) => {
          this.cultivos = cultivos.data;
          this.items = ubicaciones.data
            ? ubicaciones.data.map(ubi => {
                return { ...ubi, selected: false };
              })
            : [];
        })
        .finally(() => (this.isLoading = false));
    }
    // toggleSubUbicaciones(index) {
    //   const positionSub = this.subDetails.indexOf(index);
    //   positionSub !== -1
    //     ? this.subDetails.splice(positionSub, 1)
    //     : this.subDetails.push(index);
    // }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 50%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100%;
}
.sp-border-input {
  border-radius: 4px;
}
.sp-flex {
  flex-direction: row;
}
.sp-margin-b {
  margin-bottom: 0;
}
.sp-width-butom {
  width: 160px;
}
.cursor-p {
  cursor: pointer;
}

@media (max-width: 768px) {
  .sp-flex {
    flex-direction: column;
  }
  .sp-margin-b {
    margin-bottom: 0.8rem;
  }
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
